70079
import React, { useContext, useState, useEffect } from 'react';
import WebServiceContext from '../WebService/ServiceContext'
import { BasicContext } from '../context/BasicContext'

import { ExamContextProvider } from '../context/ExamContext'
import { ExamContext } from '../context/ExamContext'
import ExamApp from './ExamApp'

//import { Dispatch } from "redux";
//import { useDispatch } from "react-redux"
//import { setExamInfo, setExamData } from "../../reducers/exam/creators"


type CompleteData = {
    date: string
}

//type CompeteObject = ResultData & { y: number; };


//const _url = new URL(document.location.href)
//let ActID:string; 
//let ExamID:string;
//let option:string="1";//自選|非自選 預設非自選
//let RecNum:string="10";//撈回來的題數，預設10題

/*
//20220617
if(!document.referrer.match(/course||localhost/i)){
    alert("請務必從168官網進入!")
    window.open("https://168.hib.com.tw/Portal/Html/Course.html","_self");
}

if( _url.searchParams.get('ExamID') ){
    ExamID = _url.searchParams.get('ExamID') as string
}else{
    alert("ActID尚未設置ActID或ExamID，返回列表")
    window.open("./Course.html","_self");
}

if( _url.searchParams.get('ActID') ){
    ActID = _url.searchParams.get('ActID') as string
}

if( _url.searchParams.get('self') ){
    option = _url.searchParams.get('option') as string
}

*/

const Exam = () => {  
    return (                    
        <ExamContextProvider>
            <ExamApp />
        </ExamContextProvider>
    )
  
}

export default Exam;
